import { Fragment, type PropsWithChildren } from "react";

interface FloatingInputLabelProps {
  label: string;
  bold?: boolean;
  maxWidth?: number | string;
}

const FloatingInputLabel = (props: PropsWithChildren<FloatingInputLabelProps>) => {
  if (props.label == "") {
    return <Fragment>{props.children}</Fragment>;
  }
  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        width: "100%",
        maxWidth: props.maxWidth == null ? "100%" : props.maxWidth,
      }}
    >
      {props.children}
      <div
        style={{
          position: "absolute",
          top: -7,
          left: 10,
          fontWeight: props.bold == true ? "bold" : 400,
          paddingLeft: 5,
          paddingRight: 5,
          whiteSpace: "nowrap",
          overflow: "hidden",
          backgroundColor: "white",
          fontSize: 11,
          color: "rgba(0, 0, 0, 0.54)",
        }}
      >
        {props.label}
      </div>
    </div>
  );
};

export default FloatingInputLabel;
